import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative w-full min-h-screen flex flex-col justify-center items-center px-6 py-24 md:py-32 overflow-hidden" data-id="element-56">
      <div className="max-w-3xl w-full mx-auto text-center space-y-12" data-id="element-57">
        {/* Label */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="flex justify-center" data-id="element-58">
          <span className="text-[#D4A853] text-xs md:text-sm tracking-[0.2em] uppercase font-medium border-b border-[#D4A853]/30 pb-1" data-id="element-59">
            REINICIO TOTAL 35+
          </span>
        </motion.div>

        {/* Product Hero Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.92
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.15
      }} className="flex justify-center" data-id="element-60">
          <div className="relative" data-id="element-61">
            <img src="https://cdn.magicpatterns.com/uploads/e9LHe2ASsf6CiPf1ycAr79/reinicio_total.png" alt="REINICIO TOTAL — 30 Días para Mujeres de 35+" className="w-full max-w-md md:max-w-lg rounded-2xl shadow-2xl" style={{
            boxShadow: '0 0 60px rgba(212, 168, 83, 0.15), 0 25px 50px rgba(0,0,0,0.5)'
          }} data-id="element-62" />
            {/* Subtle gold glow behind image */}
            <div className="absolute inset-0 -z-10 rounded-2xl blur-3xl opacity-20" style={{
            background: 'radial-gradient(circle, #D4A853 0%, transparent 70%)'
          }} data-id="element-63" />
          </div>
        </motion.div>

        {/* Headlines */}
        <div className="space-y-6" data-id="element-64">
          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-4xl md:text-6xl font-serif text-[#F5F0E8] leading-tight" data-id="element-65">
            Tienes la vida que soñaste, pero ya no estás presente en ella.
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="text-xl md:text-2xl font-serif text-[#A89F91] italic leading-relaxed max-w-2xl mx-auto" data-id="element-66">
            El método de 30 días para apagar el Piloto Automático, recuperar tu
            energía y retomar el mando después de los 35.
          </motion.p>
        </div>

        {/* Divider */}
        <motion.div initial={{
        scaleX: 0,
        opacity: 0
      }} whileInView={{
        scaleX: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.2,
        delay: 0.6
      }} className="w-24 h-[1px] bg-[#D4A853] mx-auto opacity-50" data-id="element-67" />

        {/* The Gut Punch */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="space-y-8 text-lg md:text-xl leading-relaxed text-[#F5F0E8]/90 font-light text-left md:text-center" data-id="element-68">
          <p data-id="element-69">Mírate al espejo por un segundo.</p>

          <p data-id="element-70">
            Afuera, todo parece estar bien. Tienes la agenda llena, las metas
            cumplidas y a todos los que amas bajo control. Eres la mujer que
            «puede con todo». Pero cuando se apagan las luces, hay un secreto
            que no le confiesas a nadie:
          </p>

          <p className="text-2xl md:text-3xl text-[#D4A853] font-serif font-medium text-center" data-id="element-71">
            Te sientes profundamente vacía.
          </p>

          <p className="max-w-2xl mx-auto text-[#A89F91]" data-id="element-72">
            Te despiertas cansada antes de que empiece el día. Operas por
            inercia. Cumples expectativas ajenas mientras tu propia chispa se
            apaga. Has normalizado vivir agotada porque{' '}
            <span className="italic text-[#F5F0E8]" data-id="element-73">
              «así es la vida de adulta»
            </span>
            .
          </p>

          <p className="text-[#F5F0E8] italic font-medium" data-id="element-74">
            Pero no es cansancio. Es el peso de una vida que ya no decides tú.
          </p>
        </motion.div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 1
      }} className="pt-4" data-id="element-75">
          <motion.button whileHover={{
          scale: 1.02,
          backgroundColor: '#E8BE6A'
        }} whileTap={{
          scale: 0.98
        }} onClick={() => document.getElementById('oferta')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-[#D4A853] text-[#0D0D0D] font-bold text-lg px-8 py-4 rounded-lg shadow-lg transition-colors uppercase tracking-wide" data-id="element-76">
            QUIERO REINICIAR MI VIDA AHORA
          </motion.button>
          <p className="mt-3 text-xs text-[#A89F91]/50 uppercase tracking-wider" data-id="element-77">
            Solo $29 USD · Descarga inmediata
          </p>
        </motion.div>
      </div>

      {/* Decorative background gradient */}
      <div className="absolute top-0 left-0 w-full h-64 bg-gradient-to-b from-[#D4A853]/5 to-transparent pointer-events-none" data-id="element-78" />
    </section>;
}